module.exports = __webpack_public_path__ + "media/img/favicon/site-a1d43677fccbe6b6ae1b2d46fed8961e.webmanifest";